"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetCollectionTemplateImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing AssetCollectionTemplate operations. */
var AssetCollectionTemplateImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class AssetCollectionTemplate class.
   * @param client Reference to the service client
   */
  function AssetCollectionTemplateImpl(client) {
    (0, _classCallCheck2["default"])(this, AssetCollectionTemplateImpl);
    this.client = client;
  }
  /**
   * Retrieves the non-archived asset collection templates. (Auth: Authorize)
   * @param portalId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(AssetCollectionTemplateImpl, [{
    key: "getAssetCollectionTemplates",
    value: function getAssetCollectionTemplates(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getAssetCollectionTemplatesOperationSpec);
    }
    /**
     * Get the archived asset collection templates for the authorized user organization. (Auth: Authorize)
     * @param portalId
     * @param options The options parameters.
     */

  }, {
    key: "getArchivedAssetCollectionTemplates",
    value: function getArchivedAssetCollectionTemplates(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getArchivedAssetCollectionTemplatesOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionTemplateId])
     * @param portalId (Access Controlled)
     * @param assetCollectionTemplateId (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getAssetCollectionTemplateById",
    value: function getAssetCollectionTemplateById(portalId, assetCollectionTemplateId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionTemplateId: assetCollectionTemplateId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getAssetCollectionTemplateByIdOperationSpec);
    }
    /**
     * Archives an asset collection template. (Auth: RhinestoneAuthorize[portalId,
     * assetCollectionTemplateId])
     * @param portalId (Access Controlled)
     * @param assetCollectionTemplateId (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "archiveAssetCollectionTemplate",
    value: function archiveAssetCollectionTemplate(portalId, assetCollectionTemplateId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionTemplateId: assetCollectionTemplateId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, archiveAssetCollectionTemplateOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionTemplateId])
     * @param portalId (Access Controlled)
     * @param assetCollectionTemplateId (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getArchivedAssetCollectionTemplateById",
    value: function getArchivedAssetCollectionTemplateById(portalId, assetCollectionTemplateId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionTemplateId: assetCollectionTemplateId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getArchivedAssetCollectionTemplateByIdOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionTemplateId])
     * @param portalId (Access Controlled)
     * @param assetCollectionTemplateId (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "createAssetCollectionFromTemplate",
    value: function createAssetCollectionFromTemplate(portalId, assetCollectionTemplateId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionTemplateId: assetCollectionTemplateId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, createAssetCollectionFromTemplateOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionTemplateId])
     * @param portalId (Access Controlled)
     * @param assetCollectionTemplateId (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "createAssetCollectionFromArchivedTemplate",
    value: function createAssetCollectionFromArchivedTemplate(portalId, assetCollectionTemplateId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionTemplateId: assetCollectionTemplateId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, createAssetCollectionFromArchivedTemplateOperationSpec);
    }
    /**
     * Gets underlying asset items of an asset collection template in tree structure. (Auth:
     * RhinestoneAuthorize[portalId, assetCollectionTemplateId])
     * @param portalId (Access Controlled)
     * @param assetCollectionTemplateId (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getNodes",
    value: function getNodes(portalId, assetCollectionTemplateId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionTemplateId: assetCollectionTemplateId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getNodesOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionTemplateId])
     * @param portalId (Access Controlled)
     * @param assetCollectionTemplateId (Access Controlled)
     * @param nodeId
     * @param options The options parameters.
     */

  }, {
    key: "getNode",
    value: function getNode(portalId, assetCollectionTemplateId, nodeId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionTemplateId: assetCollectionTemplateId,
        nodeId: nodeId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getNodeOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionTemplateId])
     * @param assetCollectionTemplateId (Access Controlled)
     * @param portalId (Access Controlled)
     * @param assetItemId
     * @param options The options parameters.
     */

  }, {
    key: "downloadBlob",
    value: function downloadBlob(assetCollectionTemplateId, portalId, assetItemId, options) {
      var operationArguments = {
        assetCollectionTemplateId: assetCollectionTemplateId,
        portalId: portalId,
        assetItemId: assetItemId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, downloadBlobOperationSpec);
    }
  }]);
  return AssetCollectionTemplateImpl;
}(); // Operation Specifications


exports.AssetCollectionTemplateImpl = AssetCollectionTemplateImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getAssetCollectionTemplatesOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollectionTemplates",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssetCollectionTemplateViewModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  queryParameters: [Parameters.count],
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getArchivedAssetCollectionTemplatesOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollectionTemplates/Archived",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssetCollectionTemplateViewModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  queryParameters: [Parameters.count],
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getAssetCollectionTemplateByIdOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollectionTemplates({assetCollectionTemplateId})",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.AssetCollectionTemplateViewModel
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionTemplateId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var archiveAssetCollectionTemplateOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollectionTemplates({assetCollectionTemplateId})",
  httpMethod: "DELETE",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionTemplateId],
  serializer: serializer
};
var getArchivedAssetCollectionTemplateByIdOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollectionTemplates({assetCollectionTemplateId})/Archived",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.AssetCollectionTemplateViewModel
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionTemplateId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var createAssetCollectionFromTemplateOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollectionTemplates({assetCollectionTemplateId})/assetCollection",
  httpMethod: "POST",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionTemplateId],
  serializer: serializer
};
var createAssetCollectionFromArchivedTemplateOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollectionTemplates({assetCollectionTemplateId})/assetCollectionFromArchive",
  httpMethod: "POST",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionTemplateId],
  serializer: serializer
};
var getNodesOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollectionTemplates({assetCollectionTemplateId})/Nodes",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "NodeInfo"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionTemplateId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getNodeOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollectionTemplates({assetCollectionTemplateId})/Node({nodeId})",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.NodeInfo
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.nodeId, Parameters.assetCollectionTemplateId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var downloadBlobOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollectionTemplates({assetCollectionTemplateId})/Node({assetItemId})/Content",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Stream"
        },
        serializedName: "parsedResponse"
      }
    },
    206: {},
    401: {},
    403: {},
    406: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetItemId, Parameters.assetCollectionTemplateId],
  headerParameters: [Parameters.accept1],
  serializer: serializer
};